import { apiSlice } from './apiSlice';
import { SHIFT_URL } from '../constants';

export const shiftApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    // Create a new shift
    createShift: builder.mutation({
      query: (shiftData) => ({
        url: `${SHIFT_URL}`,
        method: 'POST',
        body: shiftData,
      }),
      invalidatesTags: ['Shift'],
    }),

    // Get all shifts
    getShifts: builder.query({
      query: () => ({
        url: `${SHIFT_URL}`,
      }),
      providesTags: ['Shift'],
      keepUnusedDataFor: 5,
    }),

    // Get approved filled shifts
    getApprovedFilledShifts: builder.query({
      query: () => ({
        url: `${SHIFT_URL}/approved-filled`,
      }),
      providesTags: ['Shift'],
      keepUnusedDataFor: 5,
    }),

    // Get a single shift by ID
    getShiftById: builder.query({
      query: (shiftId) => ({
        url: `${SHIFT_URL}/${shiftId}`,
      }),
      providesTags: (result, error, id) => [{ type: 'Shift', id }],
      keepUnusedDataFor: 5,
    }),

    // Update a shift
    updateShift: builder.mutation({
      query: (data) => ({
        url: `${SHIFT_URL}/${data.shiftId}`,
        method: 'PUT',
        body: data,
      }),
      invalidatesTags: (result, error, { shiftId }) => [
        { type: 'Shift', id: shiftId },
        'Shift'
      ],
    }),

    // Assign shift to user
    assignShiftToUser: builder.mutation({
      query: ({ shiftId, userId, managerId, userName, userEmail, lineStatus }) => ({
        url: `${SHIFT_URL}/assign/${shiftId}`,
        method: 'PUT',
        body: { userId, managerId, userName, userEmail, lineStatus },
      }),
      invalidatesTags: ['Shift'],
    }),

    // Reopen shift
    reOpenShift: builder.mutation({
      query: ({ shiftId, userId, managerId, userName, userEmail }) => ({
        url: `${SHIFT_URL}/assign/reopen/${shiftId}`,
        method: 'PUT',
        body: { userId, managerId, userName, userEmail },
      }),
      invalidatesTags: ['Shift'],
    }),

    // Assign shift to agency
    assignShiftToAgency: builder.mutation({
      query: ({ shiftId, ...body }) => ({
        url: `${SHIFT_URL}/${shiftId}/assign-agency`,
        method: 'PUT',
        body,
      }),
      invalidatesTags: ['Shift'],
    }),

    // Delete a shift
    deleteShift: builder.mutation({
      query: (shiftId) => ({
        url: `${SHIFT_URL}/${shiftId}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['Shift'],
    }),

    // ===== NEW ENDPOINTS FOR WEEKLY VIEWS =====
    
    // Get weekly shifts by staff
    getWeeklyShiftsByStaff: builder.query({
      query: ({ startDate, endDate }) => ({
        url: `${SHIFT_URL}/weekly/staff?startDate=${startDate}&endDate=${endDate}`,
      }),
      providesTags: ['Shift'],
      keepUnusedDataFor: 5,
    }),

    // Get weekly shifts by ward
    getWeeklyShiftsByWard: builder.query({
      query: ({ startDate, endDate, ward }) => ({
        url: `${SHIFT_URL}/weekly/ward?startDate=${startDate}&endDate=${endDate}${ward ? `&ward=${ward}` : ''}`,
      }),
      providesTags: ['Shift'],
      keepUnusedDataFor: 5,
    }),

    // Get available shifts (not filled)
    getAvailableShifts: builder.query({
      query: ({ startDate, endDate }) => ({
        url: `${SHIFT_URL}/available?startDate=${startDate}&endDate=${endDate}`,
      }),  
      providesTags: ['Shift'],
      keepUnusedDataFor: 5,
    }),

    //shiftApiSlice.js, getMonthlyShiftsByWard, this is the month view for stats
getMonthlyShiftsByWard: builder.query({
  query: ({ startDate, endDate, ward, jobTitle }) => ({
    //url: '/api/shifts/monthly',
    url: `${SHIFT_URL}/monthly`,
    params: { 
      startDate, 
      endDate,
      ...(ward && { ward }),
      ...(jobTitle && { jobTitle })
    }
  }),
  providesTags: ['Shift']
}),

// In shiftApiSlice.js, this is the year view for stats
getYearlyShiftsByWard: builder.query({
  query: ({ startDate, endDate, ward = '', jobTitle = '' }) => ({
    url: '/api/shifts/monthly', // Can reuse same endpoint with yearly dates
    params: { 
      startDate, 
      endDate,
      ...(ward && ward !== 'all' && { ward }),
      ...(jobTitle && jobTitle !== 'all' && { jobTitle })
    }
  }),
  providesTags: ['Shift']
}),

    // Direct staff assignment (for drag and drop)
    assignStaffToShift: builder.mutation({
      query: ({ shiftId, staffData }) => ({
        url: `${SHIFT_URL}/assign/${shiftId}`,
        method: 'PUT',
        body: staffData,
      }),
      invalidatesTags: ['Shift'],
    }),

  }),
});

export const {
  useCreateShiftMutation,
  useGetShiftsQuery,
  useGetShiftByIdQuery,
  useUpdateShiftMutation,
  useDeleteShiftMutation,
  useAssignShiftToUserMutation,
  useAssignShiftToAgencyMutation,
  useGetApprovedFilledShiftsQuery,
  useReOpenShiftMutation,
  // Export new hooks
  useGetWeeklyShiftsByStaffQuery,
  useGetWeeklyShiftsByWardQuery,
  useGetAvailableShiftsQuery,
  useAssignStaffToShiftMutation,
  useGetMonthlyShiftsByWardQuery,
  useGetYearlyShiftsByWardQuery,
} = shiftApiSlice;